// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jc-3";
export var downloadButton = "_jc-4";
export var fileContainer = "_jc-9 _jc-7";
export var fileContainerBase = "_jc-7";
export var fileContainerFixedHeight = "_jc-8 _jc-7";
export var fileInfo = "_jc-5";
export var fileInfoWidthRestricted = "_jc-6";
export var fileType = "_jc-1";
export var fileTypeName = "_jc-2";
export var image = "_jc-0";
export var link = "_jc-b";
export var overflowEllipsis = "_jc-a";